<template>
  <slot></slot>
  <a-modal title="语言翻译" :visible="visible" :width="960" :footer="null" @cancel="onCancel">
    <div class="max-h-[460px]">
      <a-table
        class="bloom-basic-table"
        bordered
        :loading="loading"
        :pagination="false"
        :columns="columns"
        :data-source="langOptions"
        :scroll="{ y: 400 }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'origin'">
            <div
              class="whitespace-break-spaces line-clamp-4 my-2"
              v-if="model[currContentId]?.richText"
              v-html="model[currContentId]?.content"
            ></div>

            <div class="whitespace-break-spaces line-clamp-4 my-2 leading-[1.5]" v-else>
              {{ model[currContentId]?.content }}
            </div>
          </template>
          <div v-if="column.dataIndex === 'value'" class="flex items-center gap-2 my-3">
            <a-input
              :disabled="disabled"
              :value="model[currContentId]?.langs[record.value]"
              @input="updateContenLang(currContentId, record.value, $event.target.value)"
            />
            <Icon
              class="!text-blue cursor-pointer"
              icon="ion:language"
              @click="translateContentLang(currContentId, record.value)"
            />
          </div>
        </template>
      </a-table>
    </div>
  </a-modal>
</template>
<script setup name="AppLangProvider">
  import useLangField from './hooks/useLangField'
  import useLangOptions from './hooks/useLangOptions'
  import useLangSiteCode from './hooks/useLangSiteCode'

  import { Icon } from 'framework/components/Icon'

  const props = defineProps({
    portType: {
      type: String,
      default: 'business', // business | customer （如果读取到siteCode, 说明是customer，不需要检查portType类型）
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultSiteCode: String,
    siteCode: String,
  })

  const { siteCodeRef, updateSiteCode } = useLangSiteCode({ props })

  const { langOptions } = useLangOptions({ props, siteCodeRef })

  const {
    loading,
    addField,
    delField,
    addContent,
    updateContenLang,
    translateContentLang,
    submit,
    model,
  } = useLangField({
    langOptions,
    siteCodeRef,
  })

  const visible = ref(false)
  const currContentId = ref()
  const onTrigger = (content) => {
    currContentId.value = content.contentId
    addContent(content)
    visible.value = true
  }
  const onCancel = () => {
    currContentId.value = null
    visible.value = false
  }

  provide('__APP_LANG__', {
    addField,
    delField,
    onTrigger,
  })

  defineExpose({
    submit,
    updateSiteCode,
  })

  const columns = [
    {
      title: '原文案',
      dataIndex: 'origin',
      width: '30%',
      customCell: (_, index) => ({
        rowSpan: index === 0 ? 9999 : 0,
      }),
    },
    {
      title: '语言',
      dataIndex: 'label',
      width: '80px',
    },
    {
      title: '文案',
      dataIndex: 'value',
    },
  ]
</script>
